import Layout from 'components/Layout';
import AppShell from 'components/Layout/AppShell';
import CmsBlocks from 'components/CmsBlocks/v2';
import useLiterals from 'utils/hooks/useLiterals';
import { ROUTE_PATH } from 'routes';
import Button from 'components/UI/Button';
import { useLocation } from 'react-router-dom';

const NotFound = () => {
  const literals = useLiterals('notFound');
  const location = useLocation();

  return (
    <Layout bottomMenu onBack>
      <AppShell>
        <CmsBlocks
          key={`path-${location.pathname}`}
          renderOnError={(
            <div className='text-center'>
              <h1 className='pt-12 mb-12'>{literals.title}</h1>
              <p className='mb-12'>{literals.description}</p>
              <Button to={ROUTE_PATH.HOME} text={literals.backToHome} />
            </div>
          )}
        />
      </AppShell>
    </Layout>
  );
};

export default NotFound;
